import {createAction, props} from '@ngrx/store';
import {HttpErrorResponse} from '@angular/common/http';
import {DahLoadingType} from '@common/components-module/core-components.models';
import {DahPaginationModel} from '@common/models/commonHTTP.models';
import {Adjustment, AdjustmentSearchParams} from '@accounting/_common/models/adjustment.models';

export const CheckState = createAction(
    '[Adjustments] Check State',
    props<{ payload: { modalView: boolean, close: boolean, items: Adjustment[] } }>()
);

export const CheckStateSuccess = createAction(
    '[Adjustments] Check State Success',
    props<{ payload: { modalView: boolean, close: boolean, items: Adjustment[] } }>()
);

export const LoadList = createAction(
    '[Adjustments] Load List',
    props<{ payload: { loading: DahLoadingType, clearState: boolean } }>()
);

export const LoadListSuccess = createAction(
    '[Adjustments] Load List Success',
    props<{ payload: { items: Adjustment[], pagination: DahPaginationModel, clearState: boolean } }>()
);

export const LoadListFailure = createAction(
    '[Adjustments] Load List Failure',
    props<{ payload: HttpErrorResponse }>()
);

export const SetPagination = createAction(
    '[Adjustments] Set Pagination',
    props<{ payload: boolean }>()
);

export const SetFilter = createAction(
    '[Adjustments] Set Filter',
    props<{ payload: AdjustmentSearchParams }>()
);

export const SetLoading = createAction(
    '[Adjustments] Set Loading',
    props<{ payload: DahLoadingType }>()
);

export const SetItemsLoading = createAction(
    '[Adjustments] Set Items Loading',
    props<{ payload: { id: string, isStart: boolean } }>()
);

export const UpdateItemSuccess = createAction(
    '[Adjustments] Update Item Success',
    props<{ payload: Adjustment }>()
);

export const DeleteItem = createAction(
    '[Adjustments] Delete Item',
    props<{ payload: Adjustment }>()
);

export const DeleteItemSuccess = createAction(
    '[Adjustments] Delete Item Success',
    props<{ payload: Adjustment }>()
);

export const DeleteItemFailure = createAction(
    '[Adjustments] Delete Item Failure',
    props<{ payload: Adjustment }>()
);

export const SetInitialState = createAction(
    '[Adjustments] Set Initial State'
);
